import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url



//created components
import HeaderStepManager from "../../../commons/headerstepmanager/HeaderStepManager.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import BlocContratJour from "../../../components/bloccontratjour/BlocContratJour.jsx";
import BlocHoraires from "../../../components/blochoraires/BlocHoraires.jsx";
import LigneTotalJour from "../../../components/lignetotaljour/LigneTotalJour.jsx";
import ModalContrat from "../../../components/modalcontrat/ModalContrat.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />

//MUI Components
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { idSpotLocSlice } from "../../../store/idSpotLocSlice.js";
import { spotsListSlice } from "../../../store/spotsListSlice.js";
import { getIdSpotLoc } from "../../../store/selectors.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//Utils
import { checkLogin } from '../../../utils/check-login.js'
//import Fetch API functions
import { getArticles, getAllContratsDay, getOneSpot, getAccessoires } from '../../../database/fetchApi.js'

// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)




function ManagerJour() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [dateRef, setDateRef] = useState(dayjs());
    const [listContrats, setListContrats] = useState([]);
    const [filteredContrats, setFilteredContrats] = useState([]);
    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [spotFilter, setSpotFilter] = useState(0);
    const [spotInfos, setSpotInfos] = useState();
    const [modeTri, setModeTri] = useState("alpha");
    const [allSpotsChecked, setAllSpotsChecked] = useState(false);
    let idSpotLoc = useSelector(getIdSpotLoc);

    const [contratId, setContratId] = useState(0);
    const [currentContrat, setCurrentContrat] = useState();
    const [open, setOpen] = useState(false);

    function handleOpen(contrat) {
        console.log("a cliqué");
        setOpen(true);
        setContratId(contrat.id_contrat);
        console.log(contrat);
        setCurrentContrat(contrat);
    };

    const handleClose = () => setOpen(false);


    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (idSpotLoc === 0) { navigate("../manager/"); }

        if (checkLogin() === false) {
            navigate("/manager/login/jour");
        }; // if no login, no token, go to login page

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccess() { //we add this inner function to manage asynchrone
            let allAccess = await getAccessoires();
            setAccessoires(allAccess)
        } //end of async function
        initAccess(); //call the inner asnchrone function


    }, [])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        console.log(dateRef);
        initContrats(dayjs(dateRef).format("YYYY-MM-DD"));

    }, [dateRef])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (open === false) {
            console.log("refresh after closing");
            initContrats(dayjs(dateRef).format("YYYY-MM-DD"));
        }

    }, [open])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        console.log(listContrats);
    }, [listContrats])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        initSpot(idSpotLoc); //call the inner asnchrone function
    }, [idSpotLoc])

    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        ContratsFiltering()
    }, [listContrats])


    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        ContratsFiltering()
    }, [allSpotsChecked])

    /* useEffect(() => { //change opening hours when spot change (idspot as dependency)

        ContratsSorter(modeTri)

    }, [modeTri]) */


    async function initSpot(id) { //we add this inner function to manage asynchrone
        let spotInfos = await getOneSpot(id);
        setSpotInfos(spotInfos)
    } //end of async function




    async function initContrats(date) {
        let allContrats = await getAllContratsDay(date);
        //keep only the paid contrats
        setListContrats([].concat(allContrats.filter((contrat) => contrat.paye > 0)));

    }

    function ContratsFiltering() {
        if (allSpotsChecked === true) {
            setFilteredContrats(listContrats);
        }
        else {
            setFilteredContrats(listContrats.filter((contrat) => contrat.spot_id === idSpotLoc));
        }

    }

    function ContratsSorter(list) {

        switch (modeTri) {
            case "depart":
                let departsJour = list.filter((contrat) => dayjs(contrat.date1).isSame(dayjs(dateRef), "day"));
                let departsJourTries = departsJour.toSorted((c1, c2) => c1.h1 > c2.h1);
                let autresDeparts = list.filter((contrat) => dayjs(contrat.date1).isBefore(dayjs(dateRef), "day"));
                return departsJourTries.concat(autresDeparts);
                break;
            case "retour":
                let retoursJour = list.filter((contrat) => dayjs(contrat.date2).isSame(dayjs(dateRef), "day"));
                let retoursJourTries = retoursJour.toSorted((c1, c2) => c1.h2 > c2.h2);
                let autresRetours = list.filter((contrat) => dayjs(contrat.date2).isAfter(dayjs(dateRef), "day"));
                return retoursJourTries.concat(autresRetours);
                break;



            default: //alpha
                //setFilteredContrats(filteredContrats.toSorted((c1, c2) => c1.Client.nom.toLowerCase() > c2.Client.nom.toLowerCase()));
                return list.toSorted((c1, c2) => c1.Client.nom.toLowerCase() > c2.Client.nom.toLowerCase());
            // code block
        }

    }



    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            <HeaderStepManager title={"Contrats du jour"} />

            <div className="manager-jour">

                <div className="manager-jour-top">
                    <div className="manager-jour-top-spot">
                        <p>Spot : {spotInfos && spotInfos.nom_spot}<i className={"list-contrat-tableau-ligne-spot-color" + idSpotLoc}></i></p>
                        <FormControlLabel
                            className="manager-jour-top-spot-checkbox"
                            /* required */
                            control={<Checkbox
                                style={{
                                    color: "#00e676",
                                }}
                                onChange={_ => setAllSpotsChecked(!allSpotsChecked)}
                                checked={allSpotsChecked}
                            />}
                            label="Tous les spots"

                        />

                    </div>

                    <div className="manager-jour-top-tri">
                        <h4>Tri par : </h4>
                        <div className={modeTri === "alpha" ? "mode-tri mode-tri-selected" : "mode-tri"} onClick={_ => setModeTri("alpha")}>Nom</div>
                        <div className={modeTri === "depart" ? "mode-tri mode-tri-selected" : "mode-tri"} onClick={_ => setModeTri("depart")}>Départ</div>
                        <div className={modeTri === "retour" ? "mode-tri mode-tri-selected" : "mode-tri"} onClick={_ => setModeTri("retour")}>Retour</div>
                    </div>

                    <div className="manager-jour-header-nav">
                        {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                            <DatePicker
                                sx={{
                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                                }}
                                value={dayjs(dateRef)}
                                label="Choisissez une date"
                                size="small"
                                onChange={(newValue) => setDateRef(dayjs(newValue))}
                                className='manager-jour-header-date-picker'
                            />
                        </LocalizationProvider>}

                        <KeyboardDoubleArrowLeftIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.subtract(1, 'day'))} />
                        <p> {dateRef.format('dddd, D MMMM YYYY')}</p>
                        <KeyboardDoubleArrowRightIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.add(1, 'day'))} />
                    </div>


                </div>

                <div className="manager-jour-bottom">
                    <LigneTotalJour contrats={filteredContrats} sens={"sorties"} dateRef={dateRef} />
                    <LigneTotalJour contrats={filteredContrats} sens={"retours"} dateRef={dateRef} />

                    <div className="manager-jour-planning">
                        <BlocHoraires />

                        {
                            ContratsSorter(filteredContrats).map((contrat) => (
                                <div onClick={_ => handleOpen(contrat)} >
                                    <BlocContratJour contrat={contrat} dateRef={dateRef} />
                                </div>

                            ))
                        }

                    </div>
                </div>

            </div>

            {currentContrat &&
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <ModalContrat currentContrat={currentContrat} articles={articles} accessoires={accessoires} setOpen={setOpen} />
                </Modal>
            }


        </main>
    )
}




export default ManagerJour